
<script>
import Store from 'store'
export default {
    name: 'CheckoutBilling_FormColumn',
    props: {
        form: Array,
        displayValidationResult: Function,
        label: Object,
    },
    methods:{
        displayOption(element,option){
            return (element.value !== option.value)
        },
        autocompleteFor(element){
            const map = {
                'Invoice.FirstName': 'billing given-name',
                'Invoice.LastName': 'billing family-name',
                'Invoice.Phone': 'billing tel',
                'Invoice.Mail': 'billing email',
                'Invoice.MailRepeat': 'billing email',
                'Invoice.CountryCode': 'billing country-name',
                'Invoice.City': 'billing address-level2',
                'Invoice.Zip': 'billing postal-code',
                'Invoice.StreetName': 'billing street-address',
                'Invoice.Floor': 'billing address-line2',
                'Invoice.CompanyName': 'organization',
                'OtherInvoice.FirstName': 'shipping given-name',
                'OtherInvoice.LastName': 'shipping family-name',
                'OtherInvoice.Phone': 'shipping tel',
                'OtherInvoice.Mail': 'shipping email',
                'OtherInvoice.MailRepeat': 'shipping email',
                'OtherInvoice.CountryCode': 'shipping country-name',
                'OtherInvoice.City': 'shipping address-level2',
                'OtherInvoice.Zip': 'shipping postal-code',
                'OtherInvoice.StreetName': 'shipping street-address',
                'OtherInvoice.Floor': 'shipping address-line2',
            }
            return map[element.name] || 'off'
        }
    }

}
</script>

<template>
    <article>
        <section class="nti-checkout-billing__section" v-for="(formcolumn,columnindex) in form" :key="columnindex">
            <div class="nti-checkout-billing__input-group">
                <template v-for="(formgroup,formgroupindex) in formcolumn" :key="formgroupindex">
                    <div class="nti-checkout-billing__input-group">
                        <template v-for="element in formgroup" :key="element.displayName">
                            <div class="nti-checkout-billing__form-group">
                                <label :for="element.displayName">
                                    <span>{{element.displayName}}</span><span v-if="element.required">*</span></label>
                                
                                <template v-if="element.type === 'select'">
                                    <select
                                        class="form-control custom-select"
                                        :class="displayValidationResult(element)"
                                        :id="element.displayName"
                                        :name="element.name"
                                        :required="element.required"
                                        :autocomplete="autocompleteFor(element)"
                                        v-model="element.value"
                                    >
                                        <template v-for="(option,optionindex) in element.options" :key="optionindex">
                                            <option :value="option.value">{{option.text}}</option>
                                        </template>
                                        
                                    </select>
                                </template>

                                <template v-else-if="element.type === 'textarea'">
                                    <textarea cols="20"
                                              class="nti-checkout-billing"
                                              :class="displayValidationResult(element)"
                                              :id="element.displayName"
                                              :name="element.name"
                                              :required="element.required"
                                              :maxlength="element.maxlength"
                                              :maxlengthvalidate="element.maxlengthvalidate"
                                              :autocomplete="autocompleteFor(element)"
                                              v-model="element.value"></textarea>
                                    <div v-if="element.maxlengthvalidate"
                                         v-bind:class="{
                                         'invalid-feedback-static' : (element.maxlengthvalidate-element.value.length < 0),
                                            'info-feedback-static': (element.maxlengthvalidate-element.value.length >= 0)
                                            }">
                                        {{ label.inputValidationMaxLengthErrorLabel }} {{ element.maxlengthvalidate }}
                                        ( <strong>{{ element.maxlengthvalidate-element.value.length }}</strong> )
                                    </div>
                                </template>

                                <template v-else>
                                    <input
                                        class="form-control"
                                        :class="displayValidationResult(element)"
                                        :id="element.displayName"
                                        :name="element.name"
                                        :required="element.required"
                                        :type="element.type"
                                        :maxlength="element.maxlength"
                                        :autocomplete="autocompleteFor(element)"
                                        v-model="element.value"
                                    />
                                </template>

                                <div v-if="element.required" class="invalid-feedback">{{ label.inputValidationErrorLabel }}</div>
                                
                            </div>
                        </template>
                    </div>
                </template>
            
            </div>
        </section>
    </article>
</template>